/**
 * Shared Sendy double opt-in subscribe helper.
 * Single source of the no-cors POST contract used by every Jackery form
 * (newsletter + competition). CORS NOTE: newsletter.ilico.io sends no
 * Access-Control-Allow-Origin, so mode:'no-cors' → opaque response. We can
 * only detect network errors; Sendy still processes the request server-side.
 */
(function () {
  'use strict';

  var SENDY_URL = 'https://newsletter.ilico.io/subscribe';

  // params: { email, name?, list, extra? } — extra is an object of custom-field
  // name → value pairs (e.g. { soutez:'ano', 'soutez-povolen-marketing':'ne' }).
  function subscribe(params) {
    var body = new URLSearchParams();
    body.set('email', params.email);
    if (params.name) body.set('name', params.name);
    body.set('list', params.list);
    body.set('subform', 'yes'); // public form, no api_key
    body.set('hp', '');          // honeypot must be empty
    body.set('gdpr', 'true');
    body.set('boolean', 'true');
    body.set('referrer', window.location.href);
    // Strip chars that break things downstream: [] truncate Sendy's
    // [field,fallback=…] tag parse (stops at first ]); <> would let copy
    // inject HTML when a custom field is rendered raw into an email body.
    // (Form-path defense-in-depth only — a direct POST bypasses this.)
    var extra = params.extra || {};
    Object.keys(extra).forEach(function (k) {
      var v = extra[k];
      if (typeof v === 'string') v = v.replace(/[<>\[\]]/g, '');
      body.set(k, v);
    });

    return fetch(SENDY_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(function () { return { ok: true }; })          // opaque → assume processed
      .catch(function () { return { ok: false, error: 'network' }; });
  }

  window.JackerySendy = { subscribe: subscribe };
})();
